import { effect as _$effect } from "@opentui/solid";
import { insert as _$insert } from "@opentui/solid";
import { createTextNode as _$createTextNode } from "@opentui/solid";
import { insertNode as _$insertNode } from "@opentui/solid";
import { setProp as _$setProp } from "@opentui/solid";
import { createElement as _$createElement } from "@opentui/solid";
import { TextAttributes } from "@opentui/core";
import { useTheme } from "@tui/context/theme";
import { useDialog } from "./dialog";
import { useKeyboard } from "@opentui/solid";
import { useKeybind } from "@tui/context/keybind";
export function DialogHelp() {
  const dialog = useDialog();
  const {
    theme
  } = useTheme();
  const keybind = useKeybind();
  useKeyboard(evt => {
    if (evt.name === "return" || evt.name === "escape") {
      dialog.clear();
    }
  });
  return (() => {
    var _el$ = _$createElement("box"),
      _el$2 = _$createElement("box"),
      _el$3 = _$createElement("text"),
      _el$5 = _$createElement("text"),
      _el$7 = _$createElement("box"),
      _el$8 = _$createElement("text"),
      _el$9 = _$createTextNode(`Press `),
      _el$0 = _$createTextNode(` to see all available actions and commands in any context.`),
      _el$1 = _$createElement("box"),
      _el$10 = _$createElement("box"),
      _el$11 = _$createElement("text");
    _$insertNode(_el$, _el$2);
    _$insertNode(_el$, _el$7);
    _$insertNode(_el$, _el$1);
    _$setProp(_el$, "paddingLeft", 2);
    _$setProp(_el$, "paddingRight", 2);
    _$setProp(_el$, "gap", 1);
    _$insertNode(_el$2, _el$3);
    _$insertNode(_el$2, _el$5);
    _$setProp(_el$2, "flexDirection", "row");
    _$setProp(_el$2, "justifyContent", "space-between");
    _$insertNode(_el$3, _$createTextNode(`Help`));
    _$insertNode(_el$5, _$createTextNode(`esc/enter`));
    _$setProp(_el$5, "onMouseUp", () => dialog.clear());
    _$insertNode(_el$7, _el$8);
    _$setProp(_el$7, "paddingBottom", 1);
    _$insertNode(_el$8, _el$9);
    _$insertNode(_el$8, _el$0);
    _$insert(_el$8, () => keybind.print("command_list"), _el$0);
    _$insertNode(_el$1, _el$10);
    _$setProp(_el$1, "flexDirection", "row");
    _$setProp(_el$1, "justifyContent", "flex-end");
    _$setProp(_el$1, "paddingBottom", 1);
    _$insertNode(_el$10, _el$11);
    _$setProp(_el$10, "paddingLeft", 3);
    _$setProp(_el$10, "paddingRight", 3);
    _$setProp(_el$10, "onMouseUp", () => dialog.clear());
    _$insertNode(_el$11, _$createTextNode(`ok`));
    _$effect(_p$ => {
      var _v$ = TextAttributes.BOLD,
        _v$2 = theme.text,
        _v$3 = theme.textMuted,
        _v$4 = theme.textMuted,
        _v$5 = theme.primary,
        _v$6 = theme.selectedListItemText;
      _v$ !== _p$.e && (_p$.e = _$setProp(_el$3, "attributes", _v$, _p$.e));
      _v$2 !== _p$.t && (_p$.t = _$setProp(_el$3, "fg", _v$2, _p$.t));
      _v$3 !== _p$.a && (_p$.a = _$setProp(_el$5, "fg", _v$3, _p$.a));
      _v$4 !== _p$.o && (_p$.o = _$setProp(_el$8, "fg", _v$4, _p$.o));
      _v$5 !== _p$.i && (_p$.i = _$setProp(_el$10, "backgroundColor", _v$5, _p$.i));
      _v$6 !== _p$.n && (_p$.n = _$setProp(_el$11, "fg", _v$6, _p$.n));
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined,
      i: undefined,
      n: undefined
    });
    return _el$;
  })();
}